// @flow

import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { HashRouter as Router, Route, Link } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Avatar from "@material-ui/core/Avatar";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";

import ListSyncObjectsView from "./views/ListSyncObjectsView";
import EditSyncObjectsView from "./views/EditSyncObjectsView";
import CreateSyncObjectView from "./views/CreateSyncObjectView";
import LoginView from "./views/LoginView";
import type { UserProfile } from "./types/user_profile";
import Routes from "./lib/routes";
import Firebase from "./lib/firebase";

type Props = {
  classes: any
};

type State = {
  user: ?UserProfile,
  anchorEl: any,
  title: string,
  showBackButton: boolean
};

const styles = theme => {
  return {
    root: {
      flexGrow: 1
    },
    flex: {
      flex: 1
    },
    arrowBack: {
      marginLeft: -12,
      marginRight: 20
    },
    bigAvatar: {
      width: 50,
      height: 50
    },
    create: {
      margin: theme.spacing.unit
    }
  };
};

class App extends Component<Props, State> {
  state = {
    user: null, // { displayName: "Phaneendra Chiruvell", email: "hi", photoURL: "hi" },
    anchorEl: null,
    title: "Sync Objects",
    showBackButton: false
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  onSignOut = async () => {
    this.handleClose();
    await Firebase.signOut();
    this.setState({ user: null });
  };

  setUser = (user: UserProfile) => {
    this.setState({ user });
  };

  setTitle = (title: string) => {
    this.setState({ title });
  };

  showBackButton = () => {
    this.setState({ showBackButton: true });
  };

  hideBackButton = () => {
    this.setState({ showBackButton: false });
  };

  render = () => {
    const { user, anchorEl } = this.state;
    const { classes } = this.props;
    const open = Boolean(anchorEl);
    return (
      <Router>
        <div className={classes.root}>
          <AppBar position="static">
            <Toolbar>
              <Route
                path="/"
                children={({ match, history }) => {
                  if (this.state.showBackButton) {
                    return (
                      <IconButton
                        className={classes.arrowBack}
                        color="inherit"
                        aria-label="Menu"
                        onClick={history.goBack}
                      >
                        <ArrowBackIcon />
                      </IconButton>
                    );
                  }
                  return null;
                }}
              />

              <Typography
                variant="title"
                color="inherit"
                className={classes.flex}
              >
                {this.state.title}
              </Typography>
              {user && (
                <div>
                  <Link to={Routes.createSyncObject()}>
                    <Button
                      className={classes.create}
                      color="primary"
                      variant="raised"
                    >
                      <AddIcon />
                      Create
                    </Button>
                  </Link>
                  <IconButton
                    aria-owns={open ? "menu-appbar" : null}
                    aria-haspopup="true"
                    onClick={this.handleMenu}
                    color="inherit"
                  >
                    <Avatar
                      alt={user.displayName}
                      src={user.photoURL}
                      className={classes.bigAvatar}
                    />
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right"
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right"
                    }}
                    open={open}
                    onClose={this.handleClose}
                  >
                    <MenuItem onClick={this.onSignOut}>Signout</MenuItem>
                  </Menu>
                </div>
              )}
            </Toolbar>
          </AppBar>
          <div>
            <Route
              path={Routes.login()}
              render={props => (
                <LoginView
                  {...props}
                  user={this.state.user}
                  setUser={this.setUser}
                  setTitle={this.setTitle}
                />
              )}
            />
            <Route
              exact
              path={Routes.listSyncObjects()}
              render={props => (
                <ListSyncObjectsView
                  {...props}
                  user={this.state.user}
                  setTitle={this.setTitle}
                  showBackButton={this.showBackButton}
                  hideBackButton={this.hideBackButton}
                />
              )}
            />
            <Route
              path={Routes.editSyncObjects()}
              render={props => (
                <EditSyncObjectsView
                  {...props}
                  user={this.state.user}
                  setTitle={this.setTitle}
                  showBackButton={this.showBackButton}
                  hideBackButton={this.hideBackButton}
                />
              )}
            />
            <Route
              path={Routes.createSyncObject()}
              render={props => (
                <CreateSyncObjectView
                  {...props}
                  user={this.state.user}
                  setTitle={this.setTitle}
                  showBackButton={this.showBackButton}
                  hideBackButton={this.hideBackButton}
                />
              )}
            />
          </div>
        </div>
      </Router>
    );
  };
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.js